/**
 * API origin — empty string in dev (Vite proxy handles /api/*).
 * Set VITE_API_URL=https://api.toiyp.me in the Railway web service's
 * environment variables so it is baked into the production bundle.
 */
export const API_ORIGIN = (import.meta.env.VITE_API_URL as string | undefined) ?? '';
